import { __extends } from "tslib";
import { ProductDirectiveBaseController } from '../common/models/product-directive-base.controller';
import { fetchBullets } from './utilities/fetch-bullets';
var ProductBulletsDirectiveController = /** @class */ (function (_super) {
    __extends(ProductBulletsDirectiveController, _super);
    function ProductBulletsDirectiveController($scope, $transclude, $element, $q) {
        var _this = _super.call(this, $scope, $transclude, $element) || this;
        _this.$scope = $scope;
        _this.$transclude = $transclude;
        _this.$element = $element;
        _this.$q = $q;
        return _this;
    }
    ProductBulletsDirectiveController.prototype.$onInit = function () {
        _super.prototype.$onInit.call(this);
    };
    ProductBulletsDirectiveController.prototype.updateFromProduct = function (productId) {
        var _this = this;
        this.transclude();
        this.$q.when(fetchBullets(productId, this.$scope.pType))
            .then(function (bullets) {
            _this.$scope.bullets = bullets || [];
            if (_this.$scope.onBulletsLoad) {
                _this.$scope.onBulletsLoad({ bullets: _this.$scope.bullets });
            }
        });
    };
    ProductBulletsDirectiveController.$inject = ['$scope', '$transclude', '$element', '$q'];
    return ProductBulletsDirectiveController;
}(ProductDirectiveBaseController));
export var ProductBulletsDirective = [
    function () {
        return {
            controller: ProductBulletsDirectiveController,
            restrict: 'E',
            scope: {
                onBulletsLoad: '&?',
                pId: '<',
                pType: '@',
            },
            transclude: true,
        };
    },
];
